import { Component, OnInit, HostListener } from '@angular/core';
import { Student } from '../student-list/student';
import { TestService } from '../_services/test.service';
import { StudentService } from '../_services/student.service';
import { Subscription } from 'rxjs';
import { KeyValue } from '@angular/common';
import { ResponsiveService } from '../_services/responsive.service';
import { ToastService } from '../_services/toast-service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Role } from '../_helpers/roles';
import { PhaseService } from 'src/app/_services/phase.service';
import { ScoreType } from 'src/app/_helpers/score.type';

import { LoaderService } from '../loader/loader.service';
@Component({
	selector: 'app-test-history-all',
	templateUrl: './test-history-all.component.html',
	styleUrls: ['./test-history-all.component.css'],
})
export class TestHistoryAllComponent implements OnInit {
	testHistory: any;
	phases;
	data;
	is_mobile = false;
	role: null;
	activeStudent: Student;
	subscriptions: Subscription[] = [];
	activePhase: any;
	fixedHeader: boolean = false;
	public scoreType = ScoreType;

	constructor(
		private studentService: StudentService,
		private testService: TestService,
		public rsp: ResponsiveService,
		public toastService: ToastService,
		private jwtHelper: JwtHelperService,
		public LoaderService: LoaderService,
		public phaseService: PhaseService,
	) {}

	ngOnInit(): void {
		this.subscriptions.push(
			this.studentService.selectedStudent$.subscribe((studentData: Student) => {
				if (studentData) {
					this.activeStudent = studentData;

					this.activePhase = localStorage.getItem('activePhase')
						? JSON.parse(localStorage.getItem('activePhase'))
						: this.activeStudent.phases.slice(-1)[0];
				} else {
					this.testHistory = [];
				}
				this.subscriptions.push(
					this.testService
						.allTestHistory(studentData.id)
						.subscribe((testData: any) => {
							this.data = testData.testHistory;
							this.phases = testData.phases;

							//this.year = Object.keys(testData.testHistory)[0];
							//this.page = Object.keys(testData.testHistory[this.year])[0];
							//this.testHistory = testData.testHistory;
						}),
				);
			}),
		);
	}

	sliceLabel(label: string) {
		var index = 0;
		for (let char of label) {
			index++;
			if (char == '.') {
				return [label.slice(0, index), label.slice(index)];
			} //Find period . to slice number from label (ex: "12." and " Reading comprehension"). Return tuple of strings.
		}
		return [label, ''];
	}

	reverseKeyOrder = (
		a: KeyValue<number, string>,
		b: KeyValue<number, string>,
	): number => {
		return a.key > b.key ? -1 : b.key > a.key ? 1 : 0;
	};

	canDelete() {
		const token = localStorage.getItem('currentUser');
		const decoded = this.jwtHelper.decodeToken(token);
		this.role = decoded.role;
		const deleteScores = decoded.canDeleteScores;
		if (
			this.role == Role.Teacher ||
			this.role == Role.Admin ||
			this.role == Role.AdminLite ||
			deleteScores
		) {
			return true;
		} else {
			return false;
		}
	}

	deleteThisScore(scoreId) {
		let submitObject: {
			scoreId: any;
			assessmentBookId: any;
			assessmentTemplateId: any;
			participantId: any;
		} = {
			scoreId: '',
			assessmentBookId: '',
			assessmentTemplateId: '',
			participantId: '',
		};
		submitObject.scoreId = scoreId;
		submitObject.assessmentBookId = this.activeStudent.assessmentBookId;
		submitObject.assessmentTemplateId = this.activeStudent.assessmentTemplateId;
		submitObject.participantId = this.activeStudent.id;
		this.subscriptions.push(
			this.testService.deletePhonicsScore(submitObject).subscribe(
				(data) => {
					this.toastService.showSuccess('Successfully Deleted');
					this.studentService.setStudent(this.activeStudent);
					//localStorage.setItem('historyPage', JSON.stringify(this.page));
				},
				(error) => {
					this.toastService.showError(error);
				},
			),
		);
	}
	phaseTitle(index) {
		return this.phases.filter((phase) => phase.assessmentBookId === index)[0]
			.title;
	}

	ngOnDestroy() {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}
}
